import * as ReactRedux from 'react-redux';
import { AppState } from '../app/app.types';
import EmailTemplateComponent from './EmailTemplateComponent';
import { push } from 'react-router-redux';
import { paths } from '../app/app.routes';
import { createEmailTemplate, getEmailTemplates, updateEmailTemplate, deleteEmailTemplate } from './Actions';

const mapDispatchToProps = (dispatch: Function) => {
  return {
    createEmailTemplate: (name: string, subject: string, html: string, automated: boolean, event: string,
      days: number, beforeAfter: string, active: boolean, content: string) =>
      dispatch(createEmailTemplate(name, subject,
        html, automated, event, days, beforeAfter, active, content)),
    updateEmailTemplate: (id: number, name: string, subject: string, html: string, automated: boolean, event: string,
      days: number, beforeAfter: string, active: boolean, content: string) =>
      dispatch(updateEmailTemplate(id, name, subject,
        html, automated, event, days, beforeAfter, active, content)),
    deleteEmailTemplate: (id: number) => dispatch(deleteEmailTemplate(id)),
    getEmailTemplates: () => dispatch(getEmailTemplates()),
    toAdminDashboard: () => dispatch(push(paths.adminDashboard)),
  };
};

const mapStateToProps = (state: AppState, ownProps) => {
  return {
    authState: state.authState,
    adminState: state.adminState,
    businessState: state.businessState,
    emailTemplateState: state.emailTemplateState,
    isMobile: ownProps.isMobile,
    open: ownProps.open,
    toggleSidebarHandler: ownProps.toggleSidebarHandler
  };
};

const EmailTemplate = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(EmailTemplateComponent);
export default EmailTemplate;


// WEBPACK FOOTER //
// ./src/emailTemplate/EmailTemplate.tsx